/**
 * @summary Main menu option types
 * @constant menuTypes
 */
export const menuTypes = {
  MENU_PARENT: "MENU_PARENT",
  MENU_OPTION_ROOT: "MENU_OPTION_ROOT",
  MENU_OPTION_CHILD: "MENU_OPTION_CHILD",
  MENU_SEPARATOR: "MENU_SEPARATOR"
};
